const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || window.location.origin,
  CARDS_URL: process.env.REACT_APP_API_URL || `${window.location.origin}/api/cards`,
  UPLOADS_URL: `${window.location.origin}/uploads`
};

export default API_CONFIG;

